import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/me_example.jpg'


const _hoisted_1 = { class: "timi-workspace-container" }
const _hoisted_2 = {
  key: 0,
  class: "system-info"
}
const _hoisted_3 = { class: "timi-workspace-content" }
const _hoisted_4 = { class: "message-feedback message-feedback--success" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "message-feedback message-feedback--error" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "message-scan-chip" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = {
  key: 0,
  style: {"position":"absolute","left":"1rem","bottom":"1rem"}
}
const _hoisted_11 = { class: "timi-form-item" }
const _hoisted_12 = ["placeholder"]
const _hoisted_13 = { key: 0 }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = {
  key: 1,
  class: "workspace-loading"
}
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = { key: 2 }
const _hoisted_19 = {
  key: 0,
  class: "employee-info-content"
}
const _hoisted_20 = { class: "card-actions-footer" }
const _hoisted_21 = { class: "profile-image" }
const _hoisted_22 = {
  key: 0,
  src: _imports_0
}
const _hoisted_23 = { class: "employee-info-presence" }
const _hoisted_24 = ["innerHTML"]
const _hoisted_25 = ["innerHTML"]
const _hoisted_26 = ["innerHTML"]
const _hoisted_27 = {
  key: 1,
  class: "main-content"
}
const _hoisted_28 = { class: "message-feedback message-feedback--error" }
const _hoisted_29 = ["innerHTML"]
const _hoisted_30 = ["innerHTML"]
const _hoisted_31 = {
  key: 1,
  class: "workspace-server-update-info"
}
const _hoisted_32 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card = _resolveComponent("Card")!
  const _component_IconButton = _resolveComponent("IconButton")!
  const _component_ButtonGroup = _resolveComponent("ButtonGroup")!
  const _component_TimeEntryList = _resolveComponent("TimeEntryList")!
  const _component_ComAddTimeEntry = _resolveComponent("ComAddTimeEntry")!
  const _component_UiNumberpad = _resolveComponent("UiNumberpad")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    false
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, "Timeout: " + _toDisplayString(this.closeTimeout) + " Last set: " + _toDisplayString(_ctx.timeoutLastSet.getHours() + ':' + _ctx.timeoutLastSet.getMinutes() + ':' + _ctx.timeoutLastSet.getSeconds()), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.workstation.uid)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["main-content", { 'time-entries-enabled': _ctx.workstation?.timeentryAllowed }])
          }, [
            _createVNode(_component_Card, {
              class: _normalizeClass([{ 'active': _ctx.actionSuccess && !_ctx.actionError}, "card-info"])
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("figure", {
                    class: "message-feedback__image",
                    innerHTML: _ctx.svg.success
                  }, null, 8, _hoisted_5)
                ])
              ]),
              _: 1
            }, 8, ["class"]),
            _createVNode(_component_Card, {
              class: _normalizeClass([{ 'active': _ctx.actionError && !_ctx.actionSuccess}, "card-info"])
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createTextVNode("2 "),
                  _createElementVNode("figure", {
                    class: "message-feedback__image",
                    innerHTML: _ctx.svg.error
                  }, null, 8, _hoisted_7)
                ])
              ]),
              _: 1
            }, 8, ["class"]),
            _createVNode(_component_Card, {
              class: _normalizeClass([{ 'active': !_ctx.employee && !_ctx.actionSuccess && !_ctx.actionError}, "card-info"])
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("figure", {
                    class: "message-scan-chip__image",
                    innerHTML: _ctx.svg.nfc
                  }, null, 8, _hoisted_9),
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t('label.scanChip')), 1)
                ]),
                false
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createElementVNode("p", null, "Last Request: " + _toDisplayString(_ctx.lastRequest), 1),
                      _createElementVNode("p", null, "Successfull: " + _toDisplayString(_ctx.lastSuccessfull), 1),
                      _createElementVNode("p", null, "Response: " + _toDisplayString(_ctx.lastResponse?.data), 1),
                      _createElementVNode("p", null, "ChipId: " + _toDisplayString(_ctx.nfcChipId), 1)
                    ]))
                  : _createCommentVNode("", true),
                false
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onTestButton('134A262D')))
                    }, "134A262D"))
                  : _createCommentVNode("", true),
                false
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 2,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onTestButton('C37B342D')))
                    }, "C37B342D"))
                  : _createCommentVNode("", true),
                false
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 3,
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onTestButton('53D32D2D')))
                    }, "53D32D2D"))
                  : _createCommentVNode("", true),
                false
                  ? (_openBlock(), _createElementBlock("form", {
                      key: 4,
                      onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmitPrevent && _ctx.onSubmitPrevent(...args)), ["prevent"])),
                      class: "form-employee-code"
                    }, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("label", null, _toDisplayString(_ctx.$t('label.employeeCode')), 1),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          placeholder: _ctx.$t('placeholder.employeeCode'),
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.eCode) = $event)),
                          onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onECodeChange && _ctx.onECodeChange(...args)))
                        }, null, 40, _hoisted_12), [
                          [_vModelText, _ctx.form.eCode]
                        ])
                      ])
                    ], 32))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["class"]),
            _createVNode(_component_Card, {
              class: _normalizeClass(["card-actions transparent", { 'active': _ctx.employee && !_ctx.actionSuccess && !_ctx.actionError}]),
              ref: "refCardTimeEntryCard",
              useTouchscroll: true
            }, {
              default: _withCtx(() => [
                (!_ctx.showNewTimeEntry && _ctx.employeeDataLoaded)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["workspace-headeractions", { 'active': _ctx.showStandardActions }])
                      }, [
                        _createVNode(_component_ButtonGroup, null, {
                          default: _withCtx(() => [
                            (_ctx.activePresence && _ctx.activePresence.come > 0 && _ctx.activePresence.go == 0)
                              ? (_openBlock(), _createBlock(_component_IconButton, {
                                  key: 0,
                                  icon: _ctx.icons.workbreak,
                                  label: (_ctx.activeBreak?.stop == 0 ? _ctx.$t('button.stop_pause') : _ctx.$t('button.pause')),
                                  primary: true,
                                  raised: true,
                                  disabled: !_ctx.presenceLoaded || _ctx.readOnly,
                                  waitForResponse: _ctx.loading.workbreak,
                                  onOnClick: _ctx.onPresencePause
                                }, null, 8, ["icon", "label", "disabled", "waitForResponse", "onOnClick"]))
                              : (_openBlock(), _createBlock(_component_IconButton, {
                                  key: 1,
                                  icon: _ctx.icons.come,
                                  label: _ctx.$t('button.come'),
                                  primary: true,
                                  raised: true,
                                  disabled: !_ctx.presenceLoaded || _ctx.readOnly,
                                  waitForResponse: _ctx.loading.presence,
                                  onOnClick: _ctx.createPresence
                                }, null, 8, ["icon", "label", "disabled", "waitForResponse", "onOnClick"])),
                            _createElementVNode("button", {
                              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onNewEntry && _ctx.onNewEntry(...args))),
                              class: _normalizeClass(["ww-button-add", { 'disabled': _ctx.readOnly }]),
                              disabled: _ctx.readOnly
                            }, [
                              _createElementVNode("i", {
                                class: "svgicon",
                                innerHTML: _ctx.store.getters.svgIcons.add
                              }, null, 8, _hoisted_15)
                            ], 10, _hoisted_14),
                            _createVNode(_component_IconButton, {
                              label: _ctx.$t('button.go'),
                              icon: _ctx.icons.go,
                              primary: true,
                              raised: true,
                              disabled: !_ctx.activePresence || (_ctx.activePresence && _ctx.activePresence.come == null) || _ctx.readOnly,
                              waitForResponse: _ctx.loading.presence,
                              onOnClick: _ctx.endPresence
                            }, null, 8, ["label", "icon", "disabled", "waitForResponse", "onOnClick"])
                          ]),
                          _: 1
                        })
                      ], 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(["workspace-presence-workbreak-action", { 'active': _ctx.showPresenceWorkbreakActions }])
                      }, [
                        (_ctx.workstation?.workbreakAllowed && _ctx.activePresence && _ctx.activePresence.come > 0 && _ctx.activePresence.go == 0)
                          ? (_openBlock(), _createBlock(_component_IconButton, {
                              key: 0,
                              icon: _ctx.icons.workbreak,
                              label: (_ctx.activeBreak?.stop == 0 ? _ctx.$t('button.stop_pause') : _ctx.$t('button.pause')),
                              primary: true,
                              raised: true,
                              disabled: !_ctx.presenceLoaded || _ctx.readOnly,
                              waitForResponse: _ctx.loading.workbreak,
                              onOnClick: _ctx.onPresencePause
                            }, null, 8, ["icon", "label", "disabled", "waitForResponse", "onOnClick"]))
                          : (_ctx.workstation?.presenceAllowed)
                            ? (_openBlock(), _createBlock(_component_IconButton, {
                                key: 1,
                                icon: _ctx.icons.come,
                                label: _ctx.$t('button.come'),
                                primary: true,
                                raised: true,
                                disabled: !_ctx.presenceLoaded || _ctx.readOnly,
                                waitForResponse: _ctx.loading.presence,
                                onOnClick: _ctx.createPresence
                              }, null, 8, ["icon", "label", "disabled", "waitForResponse", "onOnClick"]))
                            : _createCommentVNode("", true),
                        (_ctx.workstation?.presenceAllowed && _ctx.activePresence && _ctx.activePresence.go == 0 && (!_ctx.activeBreak || _ctx.activeBreak.stop != 0))
                          ? (_openBlock(), _createBlock(_component_IconButton, {
                              key: 2,
                              label: _ctx.$t('button.go'),
                              icon: _ctx.icons.go,
                              primary: true,
                              raised: true,
                              disabled: !_ctx.activePresence || (_ctx.activePresence && _ctx.activePresence.come == null) || _ctx.readOnly,
                              waitForResponse: _ctx.loading.presence,
                              onOnClick: _ctx.endPresence
                            }, null, 8, ["label", "icon", "disabled", "waitForResponse", "onOnClick"]))
                          : _createCommentVNode("", true)
                      ], 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(["workspace-presence-action", { 'active': (!_ctx.showPresenceWorkbreakActions && _ctx.showPresenceAction) }])
                      }, [
                        _createVNode(_component_IconButton, {
                          icon: _ctx.icons.come,
                          label: _ctx.$t('button.come'),
                          primary: true,
                          raised: true,
                          disabled: !_ctx.presenceLoaded || _ctx.readOnly,
                          waitForResponse: _ctx.loading.presence,
                          onOnClick: _ctx.createPresence
                        }, null, 8, ["icon", "label", "disabled", "waitForResponse", "onOnClick"])
                      ], 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(["workspace-workbreak-action", { 'active': (!_ctx.showPresenceWorkbreakActions && _ctx.showWorkbreakAction) }])
                      }, [
                        (_ctx.activePresence && _ctx.activePresence.come > 0 && _ctx.activePresence.go == 0)
                          ? (_openBlock(), _createBlock(_component_IconButton, {
                              key: 0,
                              icon: _ctx.icons.workbreak,
                              label: (_ctx.activeBreak?.stop == 0 ? _ctx.$t('button.stop_pause') : _ctx.$t('button.pause')),
                              primary: true,
                              raised: true,
                              disabled: !_ctx.presenceLoaded || _ctx.readOnly,
                              waitForResponse: _ctx.loading.presence,
                              onOnClick: _ctx.onPresencePause
                            }, null, 8, ["icon", "label", "disabled", "waitForResponse", "onOnClick"]))
                          : _createCommentVNode("", true)
                      ], 2),
                      (_ctx.workstation?.timeentryAllowed && _ctx.timeEntries.length)
                        ? (_openBlock(), _createBlock(_component_TimeEntryList, {
                            key: 0,
                            dataLoaded: _ctx.timeEntriesLoaded,
                            timeEntries: _ctx.lastTimeEntries,
                            activeTimeEntry: _ctx.activeTimeEntry,
                            resetSwipe: _ctx.resetSwipe,
                            readOnly: _ctx.readOnly,
                            timeTracked: _ctx.activeTimeTracked,
                            allowSwipe: false,
                            onOnToggle: _ctx.onToggleTimeEntry
                          }, null, 8, ["dataLoaded", "timeEntries", "activeTimeEntry", "resetSwipe", "readOnly", "timeTracked", "onOnToggle"]))
                        : _createCommentVNode("", true)
                    ]))
                  : (!_ctx.employeeDataLoaded)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _createElementVNode("i", {
                          class: "svgicon svgicon--loader",
                          innerHTML: _ctx.icons.loader
                        }, null, 8, _hoisted_17),
                        _createElementVNode("p", null, _toDisplayString(_ctx.$t('label.justAMoment')), 1)
                      ]))
                    : (_ctx.workstation?.timeentryAllowed)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          _createVNode(_component_ComAddTimeEntry, {
                            filterValue: _ctx.numberPadValue,
                            employee: _ctx.employee,
                            projects: _ctx.projects,
                            clients: _ctx.clients,
                            works: _ctx.works,
                            workstation: _ctx.workstation,
                            onCreated: _ctx.onTimeEntryCreated,
                            onTabChange: _ctx.onAddTimeEntryTabChange,
                            onCancel: _ctx.onAddTimeEntryCancel
                          }, null, 8, ["filterValue", "employee", "projects", "clients", "works", "workstation", "onCreated", "onTabChange", "onCancel"])
                        ]))
                      : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["class"])
          ], 2))
        : _createCommentVNode("", true),
      _createElementVNode("aside", {
        class: _normalizeClass(["employee-info", { 'active': _ctx.employee && !_ctx.actionSuccess && !_ctx.actionError, 'time-entries-enabled': _ctx.workstation?.timeentryAllowed }])
      }, [
        (_ctx.employee)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_IconButton, {
                  icon: _ctx.store.getters.svgIcons.arrowbackward,
                  label: _ctx.$t('button.cancel'),
                  title: _ctx.$t('button.cancel'),
                  onClick: _ctx.onCancelClick
                }, null, 8, ["icon", "label", "title", "onClick"])
              ]),
              _createElementVNode("div", _hoisted_21, [
                false
                  ? (_openBlock(), _createElementBlock("img", _hoisted_22))
                  : _createCommentVNode("", true),
                _createElementVNode("p", null, _toDisplayString(_ctx.employeeInitials), 1)
              ]),
              _createElementVNode("h1", null, _toDisplayString(_ctx.employee.firstName), 1),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("p", null, [
                  _createElementVNode("i", {
                    class: "svgicon svgicon--comego",
                    innerHTML: _ctx.icons.comego
                  }, null, 8, _hoisted_24),
                  _createTextVNode(_toDisplayString((_ctx.activePresence && _ctx.activePresence.come ? _ctx.convertTimeStamp(_ctx.activePresence.come) : '-:-')) + " / " + _toDisplayString((_ctx.activePresence && _ctx.activePresence.go ? _ctx.convertTimeStamp(_ctx.activePresence.go) : '-:-')), 1)
                ]),
                _createElementVNode("p", null, [
                  _createElementVNode("i", {
                    class: "svgicon svgicon--presence",
                    innerHTML: _ctx.icons.presence
                  }, null, 8, _hoisted_25),
                  _createTextVNode(" " + _toDisplayString(_ctx.presenceTime ? _ctx.convertSeconds(_ctx.presenceTime) : '00:00'), 1)
                ]),
                _createElementVNode("p", null, [
                  _createElementVNode("i", {
                    class: "svgicon svgicon--worktime",
                    innerHTML: _ctx.icons.worktime
                  }, null, 8, _hoisted_26),
                  _createTextVNode(" " + _toDisplayString(_ctx.convertSeconds(_ctx.daySum)), 1)
                ])
              ]),
              (_ctx.workstation?.timeentryAllowed)
                ? (_openBlock(), _createBlock(_component_UiNumberpad, {
                    key: 0,
                    value: _ctx.numberPadValue,
                    onChange: _ctx.onNumberpadChange,
                    onCancel: _ctx.onNumberpadCancel
                  }, null, 8, ["value", "onChange", "onCancel"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ], 2),
      (!_ctx.workstation.uid)
        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
            _createVNode(_component_Card, { class: "card-info active" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("figure", {
                    class: "message-feedback__image",
                    innerHTML: _ctx.svg.error
                  }, null, 8, _hoisted_29),
                  _createElementVNode("p", {
                    innerHTML: _ctx.$t('error.workstation.noSetup')
                  }, null, 8, _hoisted_30)
                ])
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.employee)
      ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
          _createElementVNode("p", null, _toDisplayString(_ctx.lastServerResponse), 1),
          false
            ? (_openBlock(), _createElementBlock("p", _hoisted_32, _toDisplayString(_ctx.updateControllerActiveDay), 1))
            : _createCommentVNode("", true),
          _createElementVNode("p", null, _toDisplayString(_ctx.convertTimeStampToDateAndTimeWithSeconds(_ctx.lastServerUpdate)), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}